module.exports = __webpack_public_path__ + "static/media/MY.6b933fac.PNG";